import {
  Grid,
  CssBaseline,
  Toolbar,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  makeStyles,
  createStyles,
  Theme,
  Collapse,
} from "@material-ui/core";
import React, { FunctionComponent, useState } from "react";
import { Navbar } from "../Navbar/Navbar";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import PeopleOutlineIcon from "@material-ui/icons/PeopleOutline";
import CardMembershipIcon from "@material-ui/icons/CardMembership";
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from "react-router-dom";
import Report from "@material-ui/icons/ListAlt";
import Users from "@material-ui/icons/Group";
import ItemReturn from "@material-ui/icons/ShoppingCart";
import Home from "@material-ui/icons/Home";
import SearchIcon from "@material-ui/icons/Search";
import BuildIcon from "@material-ui/icons/Build";
import Sync from "@material-ui/icons/Sync";
import AssignmentReturnIcon from "@material-ui/icons/AssignmentReturn";
import PauseCircleFilledIcon from "@material-ui/icons/PauseCircleFilled";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import { useStore } from "../../store";
import { useEffect } from "react";

const drawerWidth = 190;
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
    },
    drawer: {
      width: 61,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
      backgroundColor: "#2a3e52",
    },
    drawerContainer: {
      overflow: "auto",
      backgroundColor: "#2a3e52",
    },
    content: {
      flexGrow: 1,
      paddingTop: theme.spacing(3),
      marginLeft: "8em",
    },
    listRoot: {
      width: "100%",
      maxWidth: 360,
      margin: 0,
      backgroundColor: "#2a3e52",
    },
    nestedOfNested: {
      paddingLeft: theme.spacing(8),
      backgroundColor: "#2a3e52",
    },
    nested: {
      paddingLeft: theme.spacing(7),
      backgroundColor: "#2a3e52",
    },
    padding: {
      margin: 0,
    },
  })
);
const menuSchema = [
  {
    id: 1,
    title: "Home",
    link: "/",
    submenuItems: null,
    icon: <Home />,
    permission_id: null,
  },

  {
    id: 2,
    title: "Reports",
    icon: <Report />,
    permission_id: null,
    submenuItems: [
      {
        id: 1,
        title: "EOD Report",
        link: "/eod",
        permission_id: 3,
      },
    ],
  },
  {
    id: 3,
    title: "Item Return",
    link: "/itemreturn",
    icon: <ItemReturn />,
    permission_id: 2,
  },
  {
    id: 4,
    title: "Master",
    // link: "",
    permission_id: null,
    submenuItems: [
      {
        title: "Users",
        // link: "",
        permission_id: null,
        submenuItems: [
          {
            id: 1,
            title: "Store Users",
            link: "/users/store",
            submenuItems: null,
            permission_id: 7,
          },
          {
            id: 2,
            title: "Pos Users",
            link: "/users/pos",
            submenuItems: null,
            permission_id: 8,
          },
        ],
      },
      {
        id: 3,
        title: "Terminals",
        link: "/terminals",
        submenuItems: null,
        permission_id: 9,
      },
      {
        id: 4,
        title: "Roles",
        link: "/roles",
        submenuItems: null,
        permission_id: 4,
      },
      {
        id: 5,
        title: "Departments",
        link: "/departments",
        submenuItems: null,
        permission_id: 11,
      },
      {
        id: 6,
        title: "Divisions",
        link: "/divisions",
        submenuItems: null,
        permission_id: 6,
      },
      {
        title: "Configurations",
        link: "/configuration",
        permission_id: null,
        submenuItems: [
          {
            id: 7,
            title: "Store Configurations",
            link: "/configuration/store",
            submenuItems: null,
            permission_id: 14,
          },
          {
            id: 8,
            title: "Pos Configurations",
            link: "/configuration/pos",
            submenuItems: null,
            permission_id: 13,
          },
        ],
      },
      {
        id: 9,
        title: "Company Details",
        link: "/company",
        submenuItems: null,
        permission_id: 18,
      },
      {
        id: 10,
        title: "Store Details",
        link: "/store",
        submenuItems: null,
        permission_id: 20,
      },
      {
        id: 11,
        title: "Vouchers",
        link: "/vouchers",
        submenuItems: null,
        permission_id: 21,
      },
      {
        id: 11,
        title: "Currency",
        link: "/currency",
        submenuItems: null,
        permission_id: 23,
      },
    ],
    icon: <Users />,
  },
  {
    id: 5,
    title: "Search Bill",
    link: "/bills",
    submenuItems: null,
    icon: <SearchIcon />,
    permission_id: 10,
  },
  {
    id: 6,
    title: "Credit Customers",
    link: "/creditcustomers",
    submenuItems: null,
    icon: <CardMembershipIcon />,
    permission_id: 12,
  },
  {
    id: 7,
    title: "Terminal Users",
    link: "/terminalusers",
    submenuItems: null,
    icon: <PeopleOutlineIcon />,
    permission_id: 15,
  },
  // {
  //   id: 8,
  //   title: "Service Management",
  //   link: "/services/true",
  //   submenuItems: null,
  //   icon: <BuildIcon />,
  //   permission_id: 16,
  // },
  {
    id: 9,
    title: "Suspended Bills",
    icon: <PauseCircleFilledIcon />,
    link: "/suspendedBills",
    submenuItems: null,
    permission_id: 10,
  },
  {
    id: 10,
    title: "Cashier Reconciliation",
    icon: <AccountBoxIcon />,
    link: "/cashier-reconciliation",
    submenuItems: null,
    permission_id: 19,
  },
  {
    id: 11,
    title: "User Logs",
    icon: <Users />,
    link: "/user-log",
    submenuItems: null,
    permission_id: 22,
  },
  {
    id: 12,
    title: "Resync Configuration tables",
    icon: <Sync />,
    link: "/resync",
    submenuItems: null,
    permission_id: 23,
  },
  {
    id: 13,
    title: "Product Sync",
    icon: <Sync />,
    link: "/product-sync",
    submenuItems: null,
    permission_id: 24,
  },
];
type PermissionType = {
  permission_id: number;
  is_add: boolean;
  is_view: boolean;
  is_edit: boolean;
  is_delete: boolean;
}[];
export const AppLayoutBody: FunctionComponent = ({ children }) => {
  const classes = useStyles();
  const [user] = useStore("auth", "user");
  const [expanded, setExpanded] = useState<any>({});
  const [menuItems, setMenuItems] = useState<any>([]);
  const NavLink = React.forwardRef<HTMLAnchorElement, RouterLinkProps>(
    (props, ref) => <RouterLink innerRef={ref} {...props} />
  );
  localStorage.setItem("notificationCount", "false");

  useEffect(() => {
    const permissionSchema = user.permissions;

    const finalMenu: any = [];
    menuSchema.forEach((item) => {
      const data = validateItem(item, permissionSchema);
      if (data) finalMenu.push(data);
    });
    setMenuItems(finalMenu);
  }, []);

  const validateItem = (item: any, permissionSchema: PermissionType) => {
    if (user.is_super_admin === true) {
      return item;
    } else {
      if (permissionSchema.length !== 0) {
        if (item.title === "Home") {
          return item;
        } else {
          if (item.submenuItems) {
            if (item.submenuItems.length !== 0) {
              const submenu: any = [];
              item.submenuItems.forEach((subitem: any) => {
                const data = validateItem(subitem, permissionSchema);
                if (data) submenu.push(data);
              });
              if (submenu.length > 0) item.submenuItems = submenu;
              else item.submenuItems = null;
              return item;
            } else {
              const sub = permissionSchema.find(
                (permission: any) =>
                  permission.permission_id === item.permission_id
              );
              if (sub) {
                return item;
              }
            }
          } else {
            const sub = permissionSchema.find(
              (permission: any) =>
                permission.permission_id === item.permission_id
            );

            if (sub) {
              return item;
            }
          }
        }
      } else {
        if (item.title === "Home") {
          return item;
        } else {
          return null;
        }
      }
    }
  };

  const handleClick = (id: any) => {
    setExpanded({
      ...expanded,
      [id]: !expanded[id],
    });
  };

  return (
    <Grid
      item
      xs={10}
      style={{ minHeight: "97vh", paddingTop: "3em", paddingBottom: "2em" }}
    >
      <div className={classes.root}>
        <CssBaseline />
        <Navbar />
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <Toolbar />
          <div className={classes.drawerContainer}>
            {menuItems.map((item: any) => {
              if (item.submenuItems) {
                return (
                  <List
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    className={classes.listRoot}
                  >
                    <ListItem
                      button
                      onClick={() => handleClick(item.title)}
                      component={NavLink}
                      to={item.link}
                      style={{ backgroundColor: "#2a3e52" }}
                    >
                      <ListItemIcon style={{ color: "#fff" }}>
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText
                        primary={item.title}
                        style={{
                          color: "#fff",
                          fontSize: "0.815rem",
                          fontWeight: "bold",
                          marginLeft: "-1.5em",
                        }}
                      />
                      {expanded[item.title] ? (
                        <ExpandLess style={{ color: "#fff" }} />
                      ) : (
                        <ExpandMore style={{ color: "#fff" }} />
                      )}
                    </ListItem>
                    {}
                    <Collapse
                      in={expanded[item.title]}
                      timeout="auto"
                      unmountOnExit={true}
                    >
                      {item.submenuItems.map((itemSub: any) => {
                        if (itemSub.submenuItems) {
                          return (
                            <List
                              component="div"
                              style={{ backgroundColor: "#2a3e52" }}
                            >
                              <ListItem
                                button
                                onClick={() => handleClick(itemSub.title)}
                                component={NavLink}
                                to={item.link}
                              >
                                <ListItemText
                                  primary={itemSub.title}
                                  style={{
                                    color: "white",
                                    fontSize: "0.875rem",
                                    fontWeight: "bold",
                                    paddingLeft:
                                      itemSub.title === "Users"
                                        ? "2.67em"
                                        : "1.5em",
                                  }}
                                />
                                {expanded[itemSub.title] ? (
                                  <ExpandLess style={{ color: "white" }} />
                                ) : (
                                  <ExpandMore style={{ color: "white" }} />
                                )}
                              </ListItem>
                              <Divider />
                              <Collapse
                                in={expanded[itemSub.title]}
                                timeout="auto"
                                unmountOnExit
                              >
                                {itemSub.submenuItems.map(
                                  (itemSubOfSub: any) => (
                                    <List
                                      component="div"
                                      disablePadding
                                      style={{ backgroundColor: "#2a3e52" }}
                                    >
                                      <ListItem
                                        button
                                        className={classes.nestedOfNested}
                                        component={NavLink}
                                        to={itemSubOfSub.link}
                                      >
                                        <ListItemText
                                          primary={itemSubOfSub.title}
                                          style={{
                                            color: "white",
                                            fontSize: "0.875rem",
                                            fontWeight: "bold",
                                          }}
                                        />
                                      </ListItem>
                                    </List>
                                  )
                                )}
                              </Collapse>
                            </List>
                          );
                        } else {
                          return (
                            <List
                              component="div"
                              style={{
                                backgroundColor: "#2a3e52",
                                display:
                                  itemSub.permission_id !== null ? "" : "none",
                              }}
                            >
                              <ListItem
                                button
                                className={classes.nested}
                                component={NavLink}
                                to={itemSub.link}
                              >
                                <ListItemText
                                  primary={itemSub.title}
                                  style={{
                                    color: "white",
                                    fontSize: "0.815rem",
                                    fontWeight: "bold",
                                  }}
                                />
                              </ListItem>
                              <Divider
                                style={{
                                  backgroundColor:
                                    itemSub.id === item.submenuItems.length
                                      ? "#2a3e52"
                                      : "",
                                }}
                              />
                            </List>
                          );
                        }
                      })}
                    </Collapse>
                  </List>
                );
              } else {
                return (
                  <List
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    className={classes.listRoot}
                    style={{
                      display:
                        item.permission_id !== null
                          ? ""
                          : item.title !== "Home"
                          ? "none"
                          : "",
                    }}
                  >
                    <ListItem button component={NavLink} to={item.link}>
                      <ListItemIcon style={{ color: "#fff" }}>
                        {item.icon}
                      </ListItemIcon>
                      <ListItemText
                        primary={item.title}
                        style={{
                          color: "#fff",
                          fontSize: "0.815rem",
                          fontWeight: "bold",
                          marginLeft: "-1.5em",
                        }}
                      />
                    </ListItem>
                  </List>
                );
              }
            })}
          </div>
        </Drawer>
        <main className={classes.content}>
          <Toolbar />
          {children}
        </main>
      </div>
    </Grid>
  );
};
